import { DataProvider, QStack } from '@qualio/ui-components';
import {
  OwnerFilterField,
  TagsFilterField,
  TypesFilterField,
} from '../../../TableFilters';
import { FOR_TRAINING_FILTER } from '../../TrainingFilter';
import { TrainingFilter } from './TrainingFilter';

export const getLibraryTableParams = (pageParam: DataProvider.PageParams) => {
  const urlParams = pageParam.toUrlSearchParams();
  const { searchTerm } = pageParam;
  const tags = urlParams.get('filteringTag');
  const templates = urlParams.get('filteringTemplates');
  const owner = urlParams.get('owner');

  return {
    offset: urlParams.get('offset') ? Number(urlParams.get('offset')) : 0,
    limit: urlParams.get('limit') ? Number(urlParams.get('limit')) : 15,
    orderBy: urlParams.get('order_by'),
    searchTerm: searchTerm || null,
    tagsFilter: tags ? tags.split(',') : [],
    templatesFilter: templates ? templates.split(',') : [],
    ownerFilter: owner ? Number(owner) : null,
    forTraining: urlParams.get('filter_by') === FOR_TRAINING_FILTER,
  };
};

export const LibraryTableFilters = () => (
  <QStack spacing={4} direction="column">
    <TypesFilterField
      name="filteringTemplates"
      dataCy="library-template-filter"
      includeArchived={true}
    />
    <TagsFilterField name="filteringTag" dataCy="library-tags-filter" />
    <OwnerFilterField name="owner" dataCy="library-owner-filter" />
    <TrainingFilter />
  </QStack>
);
